import { createValueFormatter } from '@cmg/data-grid';

import type {
  CalendarGridColDef,
  CalendarGridKeyCreatorParams,
  CalendarGridRowData,
  CalendarGridSetFilterParams,
  CalendarGridValueFormatterFunc,
  CalendarGridValueGetterFunc,
} from '../../CalendarGrid.model';
import type { Value } from './LeftLeadCellRenderer';
import { LeftLeadCellRenderer } from './LeftLeadCellRenderer';

export const valueGetter: CalendarGridValueGetterFunc<Value> = ({ data }) => {
  return data?.managers.find(manager => manager.isLeftLead) ?? null;
};

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => value?.name ?? '-',
});

export const comparator = (
  managerA: Value | null | undefined,
  managerB: Value | null | undefined
) => {
  const managerAName = managerA?.name ?? '-';
  const managerBName = managerB?.name ?? '-';

  return managerAName.localeCompare(managerBName);
};

export const setFilterKeyCreator = ({ value }: CalendarGridKeyCreatorParams<Value>): string => {
  return value?.name ?? '(Blanks)';
};

export const setFilterValueFormatter: CalendarGridValueFormatterFunc<Value> = ({ value }) => {
  return value?.name ?? '(Blanks)';
};

const leftLeadColDef: CalendarGridColDef<Value> = {
  colId: 'leftLead',
  headerName: 'Left Lead',
  width: 222,
  valueGetter,
  valueFormatter,
  comparator,
  cellRenderer: LeftLeadCellRenderer,
  filter: 'agSetColumnFilter',
  filterParams: {
    valueFormatter: setFilterValueFormatter,
    keyCreator: setFilterKeyCreator,
  } satisfies CalendarGridSetFilterParams<Value>,
};

export default leftLeadColDef;
